export type Product = {
  id: string;
  name: string;
  price: number;
  category: string;
  image: string;
  images?: string[];
  description: string;
  details: string[];
  sizes: string[];
  colors: string[];
};

export const categories = [
  "Todos",
  "Sandalias",
  // "Camisetas",
  // "Pantalones",
  // "Suéteres",
  // "Calzado",
  // "Chaquetas",
  // "Accesorios",
] as const;

export const products: Product[] = [
  {
    id: "basic-2",
    name: "Basic #2",
    price: 26,
    category: "Sandalias",
    image: "/images/basicnegro.jpg",
    images: ["/images/basicnegro.jpg", "/images/basicbeige.jpg"],
    description: "",
    details: [
      "Memory foam",
      "Forro sintético ",
      "Suela antideslizante"
    ],
    sizes: ["37", "38", "39"],
    colors: ["Dandy café", "Milán beige"],
  },
  {
    id: "amparo",
    name: "Amparo",
    price: 28,
    category: "Sandalias",
    image: "/images/amparobeige.jpeg",
    images: ["/images/amparobeige.jpeg", "/images/amparocafe.jpg"],
    description: "",
    details: [
      "Memory foam",
      "Forro sintético ",
      "Suela antideslizante"
    ],
     sizes: ["37", "38", "39"],
    colors: ["Dandy café ", "Milán beige"],
  },
  {
    id: "roberta",
    name: "Roberta",
    price: 28,
    category: "Sandalias",
    image: "/images/IMG_48991.jpg",
    images: ["/images/IMG_48991.jpg", "/images/IMG_49031.jpg"],
    description: "",
    details: [
      "Memory foam",
      "Forro sintético ",
      "Suela antideslizante"
    ],
    sizes: ["37", "38"],
    colors: ["Champán + hebilla dorada", "Negro + hebilla plateado"],
  },
  {
    id: "katty",
    name: "Katty",
    price: 38,
    category: "Sandalias",
    image: "/images/kattyrojo.jpg",
    images: ["/images/kattyrojo.jpg"],
    description: "",
    details: [
     "Memory foam",
      "Forro sintético ",
      "Suela antideslizante"
    ],
    sizes: ["37"],
    colors: ["Vino"],
  },
  {
    id: "ballerina-noa",
    name: "Ballerina Noa",
    price: 38,
    category: "Sandalias",
    image: "/images/Ballerina.jpg",
    images: ["/images/Ballerina.jpg"],
    description: "",
    details: [
      "Memory foam",
      "Forro sintético ",
      "Suela antideslizante"
    ],
    sizes: ["38"],
    colors: ["Milán beige"],
  }
  // {
  //   id: "6",
  //   name: "Bomber Jacket Nylon",
  //   price: 165.00,
  //   category: "Chaquetas",
  //   image: "/images/product-6.png",
  //   images: ["/images/product-6.png", "/images/product-6-2.png", "/images/product-6-3.png"],
  //   description: "Chaqueta bomber en nylon mate con forro interior. Cremallera central YKK y bolsillos laterales con cremallera.",
  //   details: [
  //     "100% nylon mate",
  //     "Forro de poliéster reciclado",
  //     "Cremallera YKK",
  //     "Puños y bajo elásticos",
  //     "Bolsillos con cremallera",
  //   ],
  //   sizes: ["S", "M", "L", "XL"],
  //   colors: ["Oliva", "Negro", "Azul marino"],
  // },
  // {
  //   id: "7",
  //   name: "Jogger Felpa Francesa",
  //   price: 85.00,
  //   category: "Pantalones",
  //   image: "/images/product-7.png",
  //   images: ["/images/product-7.png", "/images/product-7-2.png", "/images/product-7-3.png"],
  //   description: "Pantalón jogger en felpa francesa de algodón. Cintura elástica con cordón y puños acanalados.",
  //   details: [
  //     "100% algodón felpa francesa",
  //     "Cintura elástica con cordón",
  //     "Bolsillos laterales",
  //     "Puños acanalados",
  //     "Corte regular",
  //   ],
  //   sizes: ["S", "M", "L", "XL", "XXL"],
  //   colors: ["Gris jaspeado", "Negro", "Azul marino"],
  // },
  // {
  //   id: "8",
  //   name: "Cinturón Cuero Premium",
  //   price: 55.00,
  //   category: "Accesorios",
  //   image: "/images/product-8.png",
  //   images: ["/images/product-8.png", "/images/product-8-2.png", "/images/product-8-3.png"],
  //   description: "Cinturón de cuero de plena flor con hebilla de aleación de zinc cepillada. Ancho de 3.5cm.",
  //   details: [
  //     "Cuero de plena flor",
  //     "Hebilla de zinc cepillada",
  //     "Ancho 3.5cm",
  //     "Borde pintado a mano",
  //     "Hecho en España",
  //   ],
  //   sizes: ["80cm", "85cm", "90cm", "95cm", "100cm"],
  //   colors: ["Marrón", "Negro"],
  // },
];
